import Image from "next/image";
import { FC } from "react";

const Header: FC = () => {
  return (
    <section className="relative">
      <div className="relative max-w-md">
        <h1 className="text-4xl font-bold md:text-5xl xl:text-6xl">
          Press & <span className="text-landing-orange">media</span>
        </h1>
        <h2 className="mt-4 text-base">
          Press kit and other relevant media resources available on request.
        </h2>
      </div>

      <ul className="mt-12">
        <li className="flex items-center mb-6 font-serif text-2xl font-thin">
          <a
            href="mailto:press@keyzy.com"
            target="_blank"
            rel="noreferrer"
            className="flex items-center"
          >
            <Image src="/contact/envelop.svg" alt="email" priority width={22} height={15} />
            <p className="ml-5 underline">press@keyzy.com </p>
          </a>
        </li>
      </ul>
    </section>
  );
};

export default Header;
